import { OrderedEnumerable } from "../OrderedEnumerable.js";
export const orderByDescending = (source, keySelector, comparer) => {
    return OrderedEnumerable.generate(source, keySelector, false, comparer);
};
